<script>
import config from '../../config'
import httpClient from '../../client'
import Common from '../general/CommonMixin.vue'
export default {
  name: 'UserStatusMixin',
  mixins: [Common],
  data () {
    return {
      STATUS_ACTIVE: 1
    }
  },
  computed: {},
  watch: {},
  methods: {
    getStatusText (status) {
      return Number(status) === this.STATUS_ACTIVE ? 'Activated' : 'Deactivated'
    },
    getStatusAccountAction (item) {
      if (Number(item.status) !== this.STATUS_ACTIVE) {
        return 'Activate Account'
      }
      return 'Deactivated Account'
    },
    getStatusEmrAction (item) {
      if (Number(item.emr_status) !== this.STATUS_ACTIVE) {
        return 'Activate EMR'
      }
      return 'Deactivate EMR'
    },

    changeStatusAccount (item) {
      this.updateStatusOfDoctor(item, 'account')
    },
    changeStatusEmr (item) {
      this.updateStatusOfDoctor(item, 'emr')
    },
    async updateStatusOfDoctor (item, type) {
      try {
        let field = type === 'account' ? 'status' : 'emr_status'
        let statusUpdate = Number(item[field]) !== this.STATUS_ACTIVE ? this.STATUS_ACTIVE : 0
        let data = {
          id: item.id,
          type: type,
          status: statusUpdate
        }
        let response = await httpClient.put(`/users/update-status-doctor`, data)
        this.processing = false
        if (response.data.s === 200) {
          if (type === 'account') {
            item.status = statusUpdate
          }
          if (type === 'emr') {
            item.emr_status = statusUpdate
          }
          this.$forceUpdate()
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processing = false
        this.alertError('Server error when update status ')
      }
    }

  }
}
</script>
